import {BetControlService} from '@gongxigames/framework/slotV2/services/BetControl/BetControlService';
import {ResponsiveLayoutService} from '@gongxigames/framework/slotV2/services/ResponsiveLayout/ResponsiveLayoutService';
import {SafeZoneService} from '@gongxigames/framework/slotV2/services/SafeZone/SafeZoneService';
import {IOSFullscreenService} from '@gongxigames/framework/slotV2/services/iOSFullscreen/IOSFullscreenService';
import {SoundService} from '@gongxigames/framework/slotV2/services/sound/SoundService';
import {BuyFeatureBetControlService} from '@gongxigames/framework/slotV2/services/BuyFeatureBetControl/BuyFeatureBetControlService';
import {SpecialInfoZoneService} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/SpecialInfoZoneService';
import {TurboControlService} from '@gongxigames/framework/slotV2/services/TurboControl/TurboControlService';

/* develblock:start */
import {DebugOverlayService} from '@gongxigames/framework/slotV2/services/DebugOverlay/DebugOverlayService';
/* develblock:end */

export const SLOT_V2_SERVICES = [
    BetControlService,
    TurboControlService,
    BuyFeatureBetControlService,
    ResponsiveLayoutService,
    SafeZoneService,
    IOSFullscreenService,
    SoundService,
    SpecialInfoZoneService,

    /* develblock:start */
    DebugOverlayService,
    /* develblock:end */
] as const;
